import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const Container = ({ children, className = "" }) => <div className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>;

export default function FAQ() {
  const [faq, setFaq] = useState([]);
  useEffect(() => { api.get("/website/faq").then(({ data }) => setFaq(data || [])); }, []);
  const cats = [...new Set(faq.map((f) => f.category))];
  return (
    <div className="py-16 md:py-20">
      <Container>
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">FAQ</span>
        <h1 className="mt-3 font-heading font-bold tracking-tight text-slate-900 text-4xl sm:text-5xl">Questions fréquentes</h1>
        {cats.map((cat) => (
          <div key={cat} className="mt-10">
            <h2 className="font-heading font-semibold text-lg text-slate-900 mb-2">{cat}</h2>
            <Accordion type="single" collapsible>
              {faq.filter((f) => f.category === cat).map((f) => (
                <AccordionItem key={f.faq_id} value={f.faq_id}>
                  <AccordionTrigger className="text-left font-medium text-slate-900">{f.question}</AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed">{f.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </Container>
    </div>
  );
}
